import { defineMessages } from "react-intl";

export const messages = defineMessages({
  profileFormName: {
    id: "profileFormName",
    defaultMessage: "Name",
  },
  profileFormFirstName: {
    id: "profileFormFirstName",
    defaultMessage: "First Name",
  },
  profileFormMiddleName: {
    id: "profileFormMiddleName",
    defaultMessage: "Middle Name (Optional)",
  },
  profileFormLastName: {
    id: "profileFormLastName",
    defaultMessage: "Last Name",
  },
  profileFormAlternativeLastName: {
    id: "profileFormAlternativeLastName",
    defaultMessage: "Alternate Last Name (Optional)",
  },
  profileFormDateOfBirth: {
    id: "profileFormDateOfBirth",
    defaultMessage: "Date of Birth",
  },
  profileFormAddress: {
    id: "profileFormAddress",
    defaultMessage: "Address",
  },
  profileFormMobileNumber: {
    id: "profileFormMobileNumber",
    defaultMessage: "Mobile Number",
  },
  profileFormZipCode: {
    id: "profileFormZipCode",
    defaultMessage: "Zip Code",
  },
  profileFormFirstNamePlaceholder: {
    id: "profileFormFirstNamePlaceholder",
    defaultMessage: "Enter Your First Name",
  },
  profileFormMiddleNamePlaceholder: {
    id: "profileFormMiddleNamePlaceholder",
    defaultMessage: "Enter Your Middle Name",
  },
  profileFormLastNamePlaceholder: {
    id: "profileFormLastNamePlaceholder",
    defaultMessage: "Enter Your Last Name",
  },
  profileFormAlternativeLastNamePlaceholder: {
    id: "profileFormAlternativeLastNamePlaceholder",
    defaultMessage: "Enter Your Alternate Last Name",
  },
  profileFormDateOfBirthPlaceholder: {
    id: "profileFormDateOfBirthPlaceholder",
    defaultMessage: "MM/DD/YYYY",
  },
  profileFormZipCodePlaceholder: {
    id: "profileFormZipCodePlaceholder",
    defaultMessage: "Enter Zip Code",
  },
  profileFormZipTooltip: {
    id: "profileFormZipTooltip",
    defaultMessage:
      "Required format: 5-digit number, or 9-digit number with a dash after the 5th digit",
  },
  profileFormFirstNameHint: {
    id: "profileFormFirstNameHint",
    defaultMessage: "Enter the same first name your clinic has on file",
  },
  profileFormLastNameHint: {
    id: "profileFormLastNameHint",
    defaultMessage: "Enter the same last name your clinic has on file",
  },
});
